import { useState, useEffect, useCallback } from 'react';
import { getDashboardIndexData } from '../api/dashboard';

const useDashboardData = (storeId) => {
  const [dashboardData, setDashboardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      const data = await getDashboardIndexData(storeId);
      setDashboardData(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }, [storeId]);
  
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { dashboardData, loading, error, refresh: fetchData };
};

export default useDashboardData;
